import { clsx } from 'clsx';
import { Callout } from '../Callout';
import patterns from '../styles/patterns.module.css';
import styles from './CTABanner.module.css';

export interface CTAAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
}

interface CTABannerProps {
  title: string;
  subtitle?: string;
  heading?: string;
  body?: string;
  pills?: string[];
  actions: CTAAction[];
  actionsAlign?: 'top' | 'bottom';
}

export function CTABanner({
  title,
  subtitle,
  heading,
  body,
  pills,
  actions,
  actionsAlign = 'top',
}: CTABannerProps) {
  return (
    <Callout variant="accent">
      <div className={clsx(styles.inner, actionsAlign === 'bottom' && styles.innerBottom)}>
        <div className={styles.content}>
          <div className={styles.title}>{title}</div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
          {heading && <div className={styles.heading}>{heading}</div>}
          {body && <div className={styles.body}>{body}</div>}
          {pills && pills.length > 0 && (
            <div className={styles.pills}>
              {pills.map((p) => <span key={p} className={patterns.pillAccent}>{p}</span>)}
            </div>
          )}
        </div>
        <div className={styles.actionGroup}>
          {actions.map((action, i) => (
            <button
              key={i}
              type="button"
              onClick={action.onClick}
              disabled={action.disabled}
              className={action.variant === 'secondary' ? patterns.ctaSecondary : patterns.ctaPrimary}
            >
              {action.label}
            </button>
          ))}
        </div>
      </div>
    </Callout>
  );
}
